/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.benefits.modals.create.controllers', [
  'ui.bootstrap'
])

.controller('MembershipBenefitsModalsCreateController', ['$scope', '$uibModalInstance', 'currentBenefit', function($scope, $uibModalInstance, currentBenefit) {

    $scope.membershipBenefitsModalsCreate = {

      model: {
        description: ''
      },

      errors: [],

      mode: 'New',

      init: function() {
        if (currentBenefit) {
          this.model = angular.copy(currentBenefit);
          this.mode = 'Update';
        }
      },

      hasErrors: function() {
        return (this.errors.length > 0);
      },

      cancel: function () {
        $uibModalInstance.dismiss('cancel');
      },

      done: function() {
        if (this.model.description && this.model.description.length) {
          $uibModalInstance.close(this.model);
        }else{
          this.errors.push({ message: 'Please enter a valid benefit'});
        }
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.membershipBenefitsModalsCreate.init();

}]);